import React from 'react';
import Navbar from './Navbar';
import Background from './Background';
import "./styles/Header.css";

const Header = ({ fadeIn, setFadeIn }) => {
    return (
        <>
            {/* <div className="header-warning"><p>Caution: You are viewing a site under development!</p></div> */}
            <Navbar fadeIn={fadeIn} setFadeIn={setFadeIn} />
            <Background fadeIn={fadeIn} setFadeIn={setFadeIn} />
            <div className="gradient-overlay"></div>
        </>
    )
}

export default Header